import { defineStore } from "pinia";
import usStatesList from "@/assets/json/us-states-list.json";

export interface AppDataStoreState {
  locations: PMC.Parking.Location[];
}

export const useAppDataStore = defineStore({
  id: "appData",
  state: (): AppDataStoreState => {
    return {
      locations: [],
    };
  },
  getters: {
    usStates() {
      return usStatesList;
    },
  },
  actions: {
    resetStore() {
      this.$reset();
    },
  },
});
